module.exports = __webpack_public_path__ + "a45b7cc0d0ca4c21298bb2322b3b8972.svg";